import React from 'react';
import { TransferenciaDePOSContent } from './TransferenciaDePOSContent';
import { TransferenciaDePOSProvider } from './contexts/TransferenciaDePOSContext';

export const TransferenciaDePOS: React.FC = () => {
  return (
    <TransferenciaDePOSProvider>
      <TransferenciaDePOSContent />
    </TransferenciaDePOSProvider>
  );
};
